export default __webpack_public_path__ + "assets/images/222c35ad9c8c31b9ad6db5a56a417036.mp3";